import React, { forwardRef } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { Box } from '@mui/material';
import EmptyChart from './EmptyChart';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

const LitersPerConnectionChart = ({ monthly = [] }, ref) => {
  const months = monthly.map((m) => m.month);
  const litersPerConn = monthly.map((m) => m.litersPerConnectionPerDay);

  const data = {
    labels: months,
    datasets: [
      {
        label: 'L / priključku / dan',
        data: litersPerConn,
        borderColor: '#2563eb',
        backgroundColor: 'rgba(37, 99, 235, 0.15)',
        tension: 0.35,
        pointRadius: 3,
        pointHoverRadius: 5,
        fill: true,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.raw} L/priključku/dan`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
      },
      y: {
        grid: {
          color: '#e5e7eb',
        },
        ticks: {
          callback: (value) => `${value}`,
        },
      },
    },
  };

  if (!monthly.length) return <EmptyChart />;

  return (
    <Box sx={{ height: { xs: 200, md: 220 } }}>
      <Line ref={ref} data={data} options={options} />
    </Box>
  );
};

export default forwardRef(LitersPerConnectionChart);
